import { type FC } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { useDynamicFormsTranslate } from "@ryde/redux";
import { parseBoolean, type ICustomField } from "@ryde/shared";

import { FieldExplanationIcon } from "../_parts";
import { FramerTooltip } from "../../../common";
import { BooleanImageIconTemplateStyled } from "./boolean-image-icon.styled";

export const BooleanImageIconTemplate: FC<ICustomField> = ({
  name,
  formLabel,
  formAttributes,
  gridAttributes,
}) => {
  const { control } = useFormContext();
  const { t } = useTranslation();
  const valueName =
    formAttributes?.fieldNameForm || gridAttributes?.fieldNameGrid || name;
  const { formLabelTranslated } = useDynamicFormsTranslate({
    name,
    fallbackText: formLabel,
  });

  return (
    <BooleanImageIconTemplateStyled>
      <Controller
        control={control}
        name={valueName}
        render={({ field: { value } }) => {
          const isOn = parseBoolean(value);
          const icon = isOn
            ? gridAttributes?.imageOn
            : gridAttributes?.imageOff;
          const tooltipKey =
            gridAttributes?.translationPath ||
            formAttributes?.tooltipTranslationKey;
          const tooltip = icon && tooltipKey ? t(tooltipKey) : undefined;

          const glyph = icon ? (
            <span
              className="BooleanImageIconTemplate-Glyph"
              role="img"
              aria-hidden
            >
              {icon}
            </span>
          ) : null;

          return (
            <div
              className="BooleanImageIconTemplate-Row"
              data-e2e-template="boolean-image-icon-template"
              data-e2e-field-name={valueName}
            >
              {tooltip ? (
                <FramerTooltip content={tooltip} rtlStrippedBottomLeftPlacement>
                  <div>{glyph}</div>
                </FramerTooltip>
              ) : (
                glyph
              )}
              <label>{formLabelTranslated}</label>
            </div>
          );
        }}
      />
      <FieldExplanationIcon formAttributes={formAttributes} />
    </BooleanImageIconTemplateStyled>
  );
};
